const LOG_FILE = "/var/log/jfermi_messages.json";
const FIFO_CONSOLE = "/dev/jfermi_console";

import * as fs 	from 'filesystem';
import FIFO from "fifo";

class Dummy {
  constructor() {
  }
}

/* an async generator that reads the input file chunk by chunk and yields each line */
async function *readline(path) {
  const MAXCHUNKSIZE = 5000;
  var lines = [""];

  var size = fs.statSync(path).size-1;
  var position = 0;
  var chunk;

  do {
    chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      position: position,
      length: MAXCHUNKSIZE
    })) );

    position += MAXCHUNKSIZE;

    chunk = chunk.split("\n");
    lines[0] += chunk.shift();
    lines = lines.concat(chunk);

    while(lines.length-1) {
      await new Promise(resolve => setTimeout(resolve, 1));
      yield lines.shift();
    }

  } while(position<size);

  return lines.shift();
}

/* reads syslog backward line by line */
/* yields every line as a json object */
async function *readlog(path) {
  const MAXCHUNKSIZE = 5000;
  var lines = [""];
  var chunk;

  var size = fs.statSync(path).size;
  var position = size-2;

  do {
    chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      position: position,
      length: MAXCHUNKSIZE
    })) );

    position -= MAXCHUNKSIZE;

    chunk = chunk.split("\n").reverse();
    lines[0] += chunk.shift();
    lines = lines.concat(chunk);

    while(lines.length-1) {
      await new Promise(resolve => setTimeout(resolve, 1));
      try {
        yield JSON.parse(lines.shift());
      } catch(e) {
        /*console.warn("Malformed syslog in /var/log/messages.json");*/
      }      
    }
  } while(position>=0);
  
  return lines.shift();
}

class LogService extends Dummy {
  constructor(...args) {
    super(...args);

    this.__log = "";

    var fifo = new FIFO();
    fifo.open(FIFO_CONSOLE);
    fifo.onmessage = this.__onmessage_handler.bind(this);
    fifo.onclose = this.__onclose_handler.bind(this);
  }
  __onclose_handler() {
    /* syslog-ng closed the pipe for some reason, reopen it */
    // syslog ng bug, closes in every minute 
    //console.info("syslog-ng closed message pipe. Re-opened.");
    var fifo = new FIFO();
    fifo.open(FIFO_CONSOLE);
    fifo.onmessage = this.__onmessage_handler.bind(this);
    fifo.onclose = this.__onclose_handler.bind(this);
  }
  __onmessage_handler(event) {
    var arrayBuffer = event.data;    
    var str = new TextDecoder().decode( new Uint8Array(arrayBuffer) );
    try {
      for (const logstr of str.split("\n")) {
        var log = JSON.parse(logstr);
        if (log.PROGRAM=="fulljs")
          clients.notifyAll("RM_log", log);
      }
    } catch(e) {
      /* JSON parse failed, it was a partial log */
      //console.warn("Failed to push a log to the clients");
    }
  }
  async RM_syslog_search(request, string, num=20) {
    var i=0;
    var logs = [];
    for await (const log of readlog(LOG_FILE)) {
      if (log.PROGRAM=="fulljs" && log.MESSAGE.includes(string)) {
        logs.push(log);
        i++;
      }
      if (i>num) break;
    }
    return logs;
  }
}

export default LogService;